export enum MUTATION_KEYS {
  CREATE_IMAGE = 'CREATE_IMAGE',
  DELETE_IMAGE = 'DELETE_IMAGE',
}

export default MUTATION_KEYS
